"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
document.addEventListener("DOMContentLoaded", function () {
  if (document.getElementById('ProductSection') !== null && document.getElementById('ProductSection').getAttribute('confi') == 'vsg-confi') {
    var changePrice = function changePrice(data) {
      var format = new Intl.NumberFormat('de-DE', {
        currency: 'EUR',
        style: 'currency'
      });
      var toPrice = function toPrice(value) {
        return format.format(parseFloat(value).toFixed(2));
      };
      var euroEdgePrice = toPrice(data.edge_processing_price * quantity.value),
        euroUnitPrice = toPrice(data.unit_price),
        euroPrice = toPrice(data.price * quantity.value);
      edge_processing_price.innerHTML = euroEdgePrice;
      price2.innerHTML = euroPrice;
      price.innerHTML = euroPrice;
      if (unit_price) unit_price.innerHTML = euroUnitPrice;
      var onSale = data.uvp > data.price;
      comparePrice.innerHTML = onSale ? number2money(data.uvp * quantity.value) : '';
      var action = onSale ? 'remove' : 'add';
      document.querySelectorAll(".badge--sale").forEach(function (element) {
        return element.classList[action]('hide');
      });
      comparePrice.classList[action]('hide');
    };
    var rest = {
      url: window.Steda.Routes.Root,
      api: 'api/v1/confi/',
      infos: 'vsg-infos',
      info: 'vsg-info/',
      save: 'vsg-save'
    };
    var regexNumber = /^[0-9]+$/;
    var shoppingCartBtn = document.getElementById('AddToCart');
    var shoppingOfferBtn = document.getElementById('offerRequest');
    var quantity = document.getElementById('Quantity');
    var length = document.getElementById('length');
    var height = document.getElementById('height');
    var thickness = document.getElementById('thickness');
    var material = document.getElementById('material');
    var color = document.getElementsByName('color');
    var edge_processing = document.getElementsByName('edge-processing');
    var edge_counter = document.getElementById('edge-counter');
    var errorBlock = document.getElementById('vsg-error-message');
    var length_min = parseInt(length.getAttribute('min'), 10);
    var length_max = parseInt(length.getAttribute('max'), 10);
    var height_min = parseInt(height.getAttribute('min'), 10);
    var height_max = parseInt(height.getAttribute('max'), 10);
    var confi = document.getElementById('confi');
    var price = document.getElementById('ProductPrice');
    var price2 = document.getElementById('confi-price');
    var unit_price = document.getElementById('unit-price');
    var edge_processing_price = document.getElementById('edge_processing_price');
    var comparePrice = document.getElementById('ComparePrice');
    var variant_id = confi.getAttribute('variantid');
    var product_handle = confi.dataset.productHandle;

    // product base data
    var section = document.getElementById('ProductSection');
    var getInfos = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var url, leng, heig, color_value, edge_processing_value, body, response, vsgData;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              url = rest.url + rest.api + rest.infos;
              leng = parseInt(length.value);
              heig = parseInt(height.value);
              color_value = document.querySelector('input[name="color"]:checked').value;
              edge_processing_value = document.querySelector('input[name="edge-processing"]:checked').value;
              edge_processing_value = edge_processing_value != "keine" ? edge_counter.value + '_' + edge_processing_value : edge_processing_value;
              body = {
                "country": Shopify.country,
                "material": material.value,
                "length": leng,
                "height": heig,
                "thickness": parseInt(thickness.value),
                "color": color_value,
                "edge_processing": edge_processing_value
              };
              if (!(checkSelectorValid() == true)) {
                _context.next = 21;
                break;
              }
              _context.next = 10;
              return fetch(url, {
                method: 'POST',
                body: JSON.stringify(body),
                headers: {
                  'Content-Type': 'application/json',
                  'Accept-Language': Shopify.locale
                }
              });
            case 10:
              response = _context.sent;
              if (!(response.status == 200)) {
                _context.next = 19;
                break;
              }
              _context.next = 14;
              return response.json();
            case 14:
              vsgData = _context.sent;
              if (shoppingCartBtn.disabled == true) {
                errorBlock.classList.remove('vsg-confi-error');
                shoppingCartBtn.disabled = false;
                shoppingOfferBtn.disabled = false;
                shoppingCartBtn.addEventListener('click', addToCart);
                // shoppingOfferBtn.addEventListener('click',addToOffer)
              }

              // TODO: Check if respone data is the same as in the form
              changePrice(vsgData);
              _context.next = 21;
              break;
            case 19:
              console.error(response);
              if (shoppingCartBtn.disabled == false) {
                errorBlock.classList.add('vsg-confi-error');
                shoppingCartBtn.disabled = true;
                shoppingOfferBtn.disabled = true;
                shoppingCartBtn.removeEventListener('click', addToCart);
                // shoppingOfferBtn.removeEventListener('click',addToOffer)
              }
            case 21:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function getInfos() {
        return _ref.apply(this, arguments);
      };
    }();
    var addToShoppingCart = function addToShoppingCart() {
      var isOffer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(event) {
          var url, leng, heig, color_value, edge_processing_value, body, response, vsgData, properties, i, payload;
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                url = rest.url + rest.api + rest.save;
                leng = parseInt(length.value);
                heig = parseInt(height.value);
                color_value = document.querySelector('input[name="color"]:checked').value;
                edge_processing_value = document.querySelector('input[name="edge-processing"]:checked').value;
                edge_processing_value = edge_processing_value != "keine" ? edge_counter.value + '_' + edge_processing_value : edge_processing_value;
                body = {
                  "country": Shopify.country,
                  "material": material.value,
                  "length": leng,
                  "height": heig,
                  "thickness": parseInt(thickness.value),
                  "color": color_value,
                  "edge_processing": edge_processing_value
                };
                _context2.next = 9;
                return fetch(url, {
                  method: 'POST',
                  body: JSON.stringify(body),
                  headers: {
                    'Content-Type': 'application/json',
                    'Accept-Language': Shopify.locale
                  }
                });
              case 9:
                response = _context2.sent;
                if (response.ok) {
                  _context2.next = 14;
                  break;
                }
                console.error(response);
                errorBlock.style.display = 'block';
                return _context2.abrupt("return");
              case 14:
                _context2.next = 16;
                return response.json();
              case 16:
                vsgData = _context2.sent;
                properties = {
                  "Konfigurationscode": vsgData.code
                };
                for (i = 0; i < vsgData.properties.length; i++) {
                  properties[vsgData.properties[i].key] = vsgData.properties[i].value;
                }
                payload = {
                  properties: properties,
                  quantity: Number(quantity.value),
                  id: Number(variant_id),
                  line_price: vsgData.price,
                  price: vsgData.price
                };
                Tracking.addItem({
                  isOffer: isOffer,
                  payload: _objectSpread(_objectSpread({}, payload), {}, {
                    handle: product_handle
                  })
                });
                fetch('/cart/add.js', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: JSON.stringify(payload)
                }).then(function (response) {
                  return response.json();
                }).then(function (data) {
                  if (isOffer) {
                    setTimeout(function () {
                      sessionStorage.setItem('Offer:Form', String(true));
                      location.href = "/cart";
                    }, 500);
                  } else {
                    setTimeout(function () {
                      fetch('/cart.json').then(function (response) {
                        return response.json();
                      }).then(function (cart) {
                        document.querySelectorAll('.item-count').forEach(function (element) {
                          element.innerHTML = cart.item_count;
                        });
                      })["catch"](function (error) {
                        console.error('Fehler:', error);
                      });
                      popupShow('shoping-cart-popup');
                    }, 500);
                  }
                })["catch"](function (error) {
                  console.error('Fehler:', error);
                });
              case 22:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }));
        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }();
    };
    var addToOffer = addToShoppingCart(true),
      addToCart = addToShoppingCart(false);

    /**
     * Sets the color option based on the selected product variant.
     */
    var setColor = function setColor() {
      var option = document.querySelector('.single-option-selector.product-single__variants option:checked');
      for (var j = 0; j < color.length; j++) {
        if (color[j].value.toLowerCase() == option.innerHTML.toLowerCase()) {
          color[j].checked = true;
          break;
        }
      }
    };
    var checkColor = function checkColor(event) {
      var target = event.target;
      var options = document.querySelectorAll('.single-option-selector.product-single__variants option');
      for (var i = 0; i < options.length; i++) {
        if (options[i].innerHTML.toLowerCase() == target.value.toLowerCase()) {
          options[i].selected = true;
          variant_id = options[i].value;
          options[i].parentElement.dispatchEvent(new Event('change'));
          break;
        }
      }
      checkData();
    };
    var checkData = function checkData() {
      var edge_processing_value = document.querySelector('input[name="edge-processing"]:checked').value;
      if (edge_processing_value == 'keine') {
        edge_counter.disabled = true;
        edge_counter.required = false;
      } else {
        edge_counter.disabled = false;
        edge_counter.required = true;
      }
      var thicknessBlock = document.querySelectorAll('.vsg-thickness p');
      for (var i = 0; i < thicknessBlock.length; i++) {
        var p = thicknessBlock[i];
        if (p.getAttribute('thickness') == thickness.value) {
          thicknessBlock[i].style.display = 'block';
        } else {
          thicknessBlock[i].style.display = 'none';
        }
      }
      if (length.value.match(regexNumber) && height.value.match(regexNumber)) {
        var length_number = parseInt(length.value, 10);
        var height_number = parseInt(height.value, 10);
        if (length_number > length_max) {
          length.value = length_max;
        } else if (height_number > height_max) {
          height.value = height_max;
        } else if (length_number < length_min) {
          length.value = length_min;
        } else if (height_number < height_min) {
          height.value = height_min;
        }
        var tmp_length = length.value;
        var tmp_height = height.value;
        setTimeout(function () {
          if (length.value == tmp_length && height.value == tmp_height) {
            getInfos();
          }
        }, 200);
      } else {
        // Highliting all Missing Fields
        shoppingCartBtn.disabled = true;
      }
    };
    var checkMaterial = function checkMaterial() {
      if (material.value == 'tvg' || material.value == 'esg') {
        var id = 'vsg_keine';
        var vsg_keine = document.getElementById(id);
        var vsg_keine_label = document.querySelector('label[for="' + id + '"]');
        if (vsg_keine.checked == true) {
          document.getElementById('vsg_kante_gesaeumt').checked = true;
        }
        if (thickness.value == "16") {
          document.getElementById('vsg_kante_poliert').checked = true;
          document.getElementById('vsg_kante_gesaeumt').disabled = true;
          document.querySelector('label[for="vsg_kante_gesaeumt"]').style.display = 'none';
        }
        vsg_keine.disabled = true;
        vsg_keine_label.style.display = 'none';
        var options = document.querySelectorAll('#edge-counter option');
        for (var i = 0; i < options.length; i++) {
          var option = options[i];
          if (option.value == "rundum") {
            option.selected = true;
          } else {
            option.disabled = true;
          }
        }
        document.getElementById('edge-counter').parentElement.style.display = 'none';
      }
    };
    var loadConfig = function loadConfig(code) {
      var url = rest.url + rest.api + rest.info + code;
      var xmlHttp = new XMLHttpRequest();
      xmlHttp.onreadystatechange = function () {
        if (xmlHttp.readyState == 4 && xmlHttp.status == 200) {
          var vsgData = JSON.parse(xmlHttp.responseText);
          if (material.classList.contains('hidden') == false) {
            material.value = vsgData.material;
          }
          if (thickness.classList.contains('hidden') == false) {
            thickness.value = vsgData.thickness;
          }
          length.value = vsgData.length;
          height.value = vsgData.height;
          for (var i = 0; i < color.length; i++) {
            if (color[i].value == vsgData.color) {
              color[i].checked = true;
              break;
            }
          }
          if (vsgData.edge_processing.includes('keine')) {
            document.getElementById('vsg_keine').checked = true;
          } else if (vsgData.edge_processing.includes('poliert')) {
            document.getElementById('vsg_kante_poliert').checked = true;
          } else if (vsgData.edge_processing.includes('gesaeumt')) {
            document.getElementById('vsg_kante_gesaeumt').checked = true;
          }
          if (vsgData.edge_processing.includes('rundum')) {
            edge_counter.querySelector('option[value="rundum"]').selected = true;
          } else if (vsgData.edge_processing.includes('1_kante')) {
            edge_counter.querySelector('option[value="1_kante"]').selected = true;
          } else if (vsgData.edge_processing.includes('2_kanten')) {
            edge_counter.querySelector('option[value="2_kanten"]').selected = true;
          }
          loadListener();
        }
      };
      xmlHttp.open("GET", url, true);
      xmlHttp.setRequestHeader('Accept-Language', Shopify.locale);
      xmlHttp.send(null);
    };
    var loadListener = function loadListener() {
      length.onchange = checkData;
      height.onchange = checkData;
      material.onchange = checkData;
      thickness.onchange = checkData;
      edge_counter.onchange = checkData;
      quantity.onchange = checkData;
      for (var i = 0; i < color.length; i++) {
        color[i].onclick = checkColor;
      }
      for (var _i = 0; _i < edge_processing.length; _i++) {
        edge_processing[_i].onclick = checkData;
      }
      shoppingCartBtn.addEventListener('click', addToCart);
      shoppingOfferBtn.addEventListener('click', addToOffer);
      quantity.parentElement.querySelectorAll('span')[0].onclick = checkData; // -
      quantity.parentElement.querySelectorAll('span')[1].onclick = checkData; // +
      checkData();
    };
    checkMaterial();
    var queryDict = {};
    location.search.substr(1).split("&").forEach(function (item) {
      queryDict[item.split("=")[0]] = item.split("=")[1];
    });
    if (typeof queryDict.code !== "undefined") {
      loadConfig(queryDict.code);
    } else {
      setColor();
      loadListener();
    }
  }
});